/*
|--------------------------------------------------------------------------
| Utility: getLocalizedTranslation.js
| Author: Sayed Ahmed
| Description: Returns the most appropriate translation for the given language slug.
|              Falls back to the first translation if no exact match is found.
|--------------------------------------------------------------------------
*/

/**
 * Finds the translation object matching the current language slug.
 *
 * @param {Array} translations - List of translation objects.
 * @param {string} currentLangSlug - Current active language (e.g., "en", "ar").
 * @returns {Object|null} The matching translation, or first fallback.
 */
export const getLocalizedTranslation = (
  translations = [],
  currentLangSlug = "en"
) => {
  // Return null if input is not a valid array
  if (!Array.isArray(translations) || translations.length === 0) return null;

  // Find the translation matching the given language slug (e.g., "en", "en-US")
  const matchedTranslation = translations.find(t =>
    t?.locale?.startsWith(currentLangSlug)
  );

  // Return the matched translation or fallback to the first one
  return matchedTranslation || translations[0];
};
